import React from "react";
import { Box } from "@mui/material";
import PerformanceItem from "./PerformanceItem";

export default function PostPerformance() {
  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.headingText}>POST PERFORMANCE</Box>

      <Box
        sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}
      >
        <PerformanceItem title="Reach" value="39.2k" />
        <PerformanceItem title="Likes" value="5,300" />
        <PerformanceItem title="Comments" value="100" />
        <PerformanceItem title="Saves" value="123" />
      </Box>
    </Box>
  );
}

const styles = {
  wrapper: {
    backgroundColor: "#FFFFFF",
    borderRadius: "14px",
    padding: "16px",
    boxShadow: "rgba(18, 38, 27, 0.05) 0px 1px 3px",
  },
  headingText: {
    color: "#8a938a",
    fontFamily: "FustatSemiBold",
    fontSize: "13px",
    mb: 2,
    letterSpacing: "0.6px",
  },
};
